<shared-document-details [document]="document" [backLink]="backLink" [flagString]="flagString"></shared-document-details>
